// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ojOhu","label":"styles_label__KLE3X","icon":"styles_icon__Uv7dV"};